import styled from '@emotion/styled';
import { getColor, getLighterColor } from '../../../theme/colors/colors';
import { useNavigate } from 'react-router-dom';
import { Logout } from '../../auth/Logout';
import { StyledLink } from '../../../util/styles-util';
import { useEffect, useState } from 'react';
import { warrantService } from '../../../api/services/warrant.service';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

const Sidebar = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminExpanded, setAdminExpanded] = useState(false);

  useEffect(() => {
    warrantService
      .isCurrentUserAdmin()
      .then(setIsAdmin)
      .catch(() => setIsAdmin(false));
  }, []);

  return (
    <MainSidebar>
      <TopLinks>
        <StyledLink onClick={() => navigate('/')}>
          <ArticleOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
          Deals
        </StyledLink>
        {isAdmin && (
          <AdminSection>
            <AdminToggle onClick={() => setAdminExpanded((prev) => !prev)}>
              <AdminToggleLabel>
                <SettingsOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
                <span>Admin</span>
              </AdminToggleLabel>
              <Arrow expanded={adminExpanded}>▶</Arrow>
            </AdminToggle>
            {adminExpanded && (
              <AdminLinks>
                <StyledLink onClick={() => navigate('/organization/list')}>
                  <BusinessOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
                  Organizations
                </StyledLink>
                <StyledLink onClick={() => navigate('/buyer-seat/list')}>
                  <CreditCardOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
                  Buyer Seats
                </StyledLink>
              </AdminLinks>
            )}
          </AdminSection>
        )}
      </TopLinks>
      <Spacer />
      <BottomLinks>
        <Logout />
      </BottomLinks>
      <DocumentLink href="https://cwire.notion.site/d13f0d1ccc2d43269b6be01306663ff1?v=65eed28fb51d4952b6f79c45942d8753" target="_blank">Documentation</DocumentLink>
    </MainSidebar>
  );
};

export default Sidebar;

const MainSidebar = styled.aside`
  height: 100%;
  width: 204px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 8px 25px;
  background-color: ${getLighterColor('primary', 7)};
  color: ${getColor('primaryContrast')};
`;

const TopLinks = styled.div`
  display: flex;
  margin-top: 32px;
  flex-direction: column;
  width: 100%;
`;

const BottomLinks = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 16px;
`;

const AdminSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;

const AdminToggle = styled.div`
  width: 100%;
  padding: 14px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background-color: ${getLighterColor('primary', 14)};
    border-radius: 4px;
  }
`;

const AdminToggleLabel = styled.div`
  display: flex;
  align-items: center;
`;

const Arrow = styled.span<{ expanded: boolean }>`
  font-size: 10px;
  transform: ${({ expanded }) => (expanded ? 'rotate(90deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
`;

const AdminLinks = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;
`;

const Spacer = styled.div`
  flex-grow: 1;
`;

export const DocumentLink = styled.a`
  width: 100%;
  padding: 4px 16px;
  cursor: pointer;
  text-decoration: none;
  color: white;

  &:hover {
    background-color: ${getLighterColor('primary', 14)};
    border-radius: 4px;
  }
`;
